<template>
    <div></div>
</template>

<script>
// 서버(/api/kcb/return)가 결과를 query 로 실어 보낸다. 부모 창의 authComplete 로 넘기고 창을 닫는다.
// error 가 실려 오면 알리기만 하고 authComplete 는 부르지 않는다 (KCP 때 실패 시 아무 이벤트도 없던 것과 같다).
// 모바일은 iframe 안에서 열려 window.close() 가 듣지 않으므로, 부모의 authClose 로 iframe 을 닫는다.
export default {
    beforeCreate(){
        const { error, ...payload } = this.$route.query;
        const inFrame = window.parent !== window;

        if (error) {
            alert(error);
            if (inFrame) window.parent.authClose?.();
        }
        else {
            if (inFrame) window.parent.authComplete?.(payload);
            opener?.window?.authComplete?.(payload);
        }
        window.close();
    }
}
</script>
